// Common currencies for global SMB use. Symbols come from Intl when rendering.
export const CURRENCIES = [
  { code: "USD", label: "US Dollar (USD)" },
  { code: "EUR", label: "Euro (EUR)" },
  { code: "GBP", label: "British Pound (GBP)" },
  { code: "CAD", label: "Canadian Dollar (CAD)" },
  { code: "AUD", label: "Australian Dollar (AUD)" },
  { code: "NZD", label: "New Zealand Dollar (NZD)" },
  { code: "JPY", label: "Japanese Yen (JPY)" },
  { code: "CNY", label: "Chinese Yuan (CNY)" },
  { code: "HKD", label: "Hong Kong Dollar (HKD)" },
  { code: "SGD", label: "Singapore Dollar (SGD)" },
  { code: "INR", label: "Indian Rupee (INR)" },
  { code: "IDR", label: "Indonesian Rupiah (IDR)" },
  { code: "MYR", label: "Malaysian Ringgit (MYR)" },
  { code: "THB", label: "Thai Baht (THB)" },
  { code: "PHP", label: "Philippine Peso (PHP)" },
  { code: "VND", label: "Vietnamese Dong (VND)" },
  { code: "KRW", label: "South Korean Won (KRW)" },
  { code: "TWD", label: "Taiwan Dollar (TWD)" },
  { code: "AED", label: "UAE Dirham (AED)" },
  { code: "SAR", label: "Saudi Riyal (SAR)" },
  { code: "ILS", label: "Israeli Shekel (ILS)" },
  { code: "TRY", label: "Turkish Lira (TRY)" },
  { code: "EGP", label: "Egyptian Pound (EGP)" },
  { code: "ZAR", label: "South African Rand (ZAR)" },
  { code: "NGN", label: "Nigerian Naira (NGN)" },
  { code: "KES", label: "Kenyan Shilling (KES)" },
  { code: "GHS", label: "Ghanaian Cedi (GHS)" },
  { code: "MAD", label: "Moroccan Dirham (MAD)" },
  { code: "BRL", label: "Brazilian Real (BRL)" },
  { code: "MXN", label: "Mexican Peso (MXN)" },
  { code: "ARS", label: "Argentine Peso (ARS)" },
  { code: "CLP", label: "Chilean Peso (CLP)" },
  { code: "COP", label: "Colombian Peso (COP)" },
  { code: "PEN", label: "Peruvian Sol (PEN)" },
  { code: "CHF", label: "Swiss Franc (CHF)" },
  { code: "SEK", label: "Swedish Krona (SEK)" },
  { code: "NOK", label: "Norwegian Krone (NOK)" },
  { code: "DKK", label: "Danish Krone (DKK)" },
  { code: "PLN", label: "Polish Zloty (PLN)" },
  { code: "CZK", label: "Czech Koruna (CZK)" },
  { code: "HUF", label: "Hungarian Forint (HUF)" },
  { code: "RON", label: "Romanian Leu (RON)" },
  { code: "BGN", label: "Bulgarian Lev (BGN)" },
  { code: "ISK", label: "Icelandic Krona (ISK)" },
  { code: "RUB", label: "Russian Ruble (RUB)" },
  { code: "UAH", label: "Ukrainian Hryvnia (UAH)" },
  { code: "PKR", label: "Pakistani Rupee (PKR)" },
  { code: "BDT", label: "Bangladeshi Taka (BDT)" },
  { code: "LKR", label: "Sri Lankan Rupee (LKR)" },
  { code: "QAR", label: "Qatari Riyal (QAR)" },
  { code: "KWD", label: "Kuwaiti Dinar (KWD)" },
  { code: "BHD", label: "Bahraini Dinar (BHD)" },
];

export function detectDefaultCurrency() {
  try {
    const locale = navigator.language || "en-US";
    // Heuristic: ask Intl for the locale's default currency via Intl.NumberFormat
    const nf = new Intl.NumberFormat(locale, { style: "currency", currency: "USD" });
    const opts = nf.resolvedOptions();
    // resolvedOptions doesn't expose the locale's default currency directly; map by region
    const region = (locale.split("-")[1] || "").toUpperCase();
    const map = {
      US: "USD", CA: "CAD", GB: "GBP", IE: "EUR", DE: "EUR", FR: "EUR", IT: "EUR",
      ES: "EUR", PT: "EUR", NL: "EUR", BE: "EUR", AT: "EUR", FI: "EUR", GR: "EUR",
      AU: "AUD", NZ: "NZD", JP: "JPY", CN: "CNY", HK: "HKD", SG: "SGD", IN: "INR",
      ID: "IDR", MY: "MYR", TH: "THB", PH: "PHP", VN: "VND", KR: "KRW", TW: "TWD",
      AE: "AED", SA: "SAR", IL: "ILS", TR: "TRY", EG: "EGP", ZA: "ZAR", NG: "NGN",
      KE: "KES", GH: "GHS", MA: "MAD", BR: "BRL", MX: "MXN", AR: "ARS", CL: "CLP",
      CO: "COP", PE: "PEN", CH: "CHF", SE: "SEK", NO: "NOK", DK: "DKK", PL: "PLN",
      CZ: "CZK", HU: "HUF", RO: "RON", BG: "BGN", IS: "ISK", RU: "RUB", UA: "UAH",
      PK: "PKR", BD: "BDT", LK: "LKR", QA: "QAR", KW: "KWD", BH: "BHD",
    };
    return map[region] || (opts.currency || "USD");
  } catch {
    return "USD";
  }
}
